(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-ta-product]').forEach(card => {
      const select = card.querySelector('[data-ta-select]');
      if (!select || select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const form = card.querySelector('product-form');
        const button = card.querySelector('[name="add"]');
        const locked = card.dataset.locked === 'true';
        card.querySelector('[data-ta-price]').textContent = option.dataset.price;
        card.querySelector('[data-ta-regular]').textContent = option.dataset.regular;
        card.querySelector('[data-ta-regular-wrap]').hidden = !option.dataset.regular;
        card.querySelector('[data-ta-contents]').textContent = option.dataset.contents;
        const link = card.querySelector('[data-ta-detail]');
        const url = new URL(link.href, location.origin);
        url.searchParams.set('variant', option.value);
        link.href = url.pathname + url.search;
        if (form.handleErrorMessage) form.handleErrorMessage();
        form.error = false;
        button.removeAttribute('aria-disabled');
        button.disabled = locked || option.dataset.available !== 'true';
        if (!locked) button.querySelector('span').textContent = option.dataset.available === 'true' ? card.dataset.add : card.dataset.soldout;
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
